module.exports = __webpack_public_path__ + "static/jerome-cd19eff94a13bcb7088496776ee7b3bf.jpg";